/* eslint-disable guard-for-in */
import React from 'react';
import { useHistory } from 'react-router-dom';
import * as _ from 'lodash';
import { Formik } from 'formik';
import {
  Container,
  Grid,
  // Modal,
  // Confirm,
  Button,
  Segment,
} from 'semantic-ui-react';
// import { toastr } from 'toastr';
import { useSelector, useDispatch } from 'react-redux';
import { TaskFormField, PICKLIST_OPTIONS, RESOLVED_VIA } from './lib/constants';
import {
  isFormAttributeHiddenOrInvalid,
  mapFormValuesToEntity,
  validateMandatoryAttribute,
} from '../../../../HelperMethods/FormUtils';
import ShouldComponentRender from '../../../common/ShouldComponentRender';

import { ENTITY_ACCESS_TYPE, RESOURCE_TYPE, RESOURCES } from '../../../../HelperMethods/role-resource-constants';
import { EVENT_SOURCE, STATUS_LIST, TASK_PRIORITY } from '../../../../HelperMethods/enums';
import { CONTAINERS, resetView, closeView } from '../../../common/cardNavigationComponent/cardNavigationRedux';
import UserCard from '../../../common/userCard/UserCard';

import { editBulkTasks } from '../redux/actions';
import { stopBulkEditPageLoading, bulkEditPageLoading } from '../redux/reducer';
import Joyn2Loader from '../../../common/Joyn2Loader';
import './bulkEditformStryling.css';
import * as taskActions from './redux/actions';
import FormHeader from '../../../common/FormHeader';
import { upsertComment } from '../../../../actions/commentActions';
import CardNavigationComponent from '../../../common/cardNavigationComponent/CardNavigationComponent';
import { mergeAttributesForBulkEditTasks } from '../helper';
import { parseJSONStringToObject } from '../../../../HelperMethods/UtilityFunctions';
import { getOperatorIdAndEquipmentId } from '../../../../HelperMethods/TaskUtilities';
import { ATTACHMENT_SCHEMA } from './lib/schemaConstants';
import { changeRecurringRule } from './lib/helper';

const addComments = ({ dispatch, reqAssignee, loggedInUser, taskObj, type = 'accept', selectedField }) => {
  if (_.isArray(reqAssignee)) {
    const userName = _.get(reqAssignee[0], 'originalobject.userName');

    dispatch(
      upsertComment({
        comment: `${type === 'accept' ? 'Accepted' : 'Rejected'} Task for ${reqAssignee[0].text} (${userName}) by ${
          loggedInUser.firstName || ''
        } ${loggedInUser.lastName || ''} (${loggedInUser.userName})`,
        fieldId: _.get(taskObj, 'fieldId') || selectedField.id,
        taskId: taskObj.id,
        autoGenerated: true,
      })
    );
  }
};

const BulkEditTaskForm = ({ handleClearSelectedTasks }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const cancelTask = () => {
    history.goBack();
  };
  const eventSourceOptions = Object.values(EVENT_SOURCE).map((option) => {
    return { key: option, value: option, text: option };
  });
  const priorityOptions = Object.values(TASK_PRIORITY).map((option) => {
    return { key: option.text, value: option.text, text: option.text };
  });
  const statusOptions = Object.values(STATUS_LIST).map((option) => ({
    key: option.key,
    value: option.key,
    text: option.text,
  }));
  const customPicklistOptions = useSelector((state) => state.manageTaskFormReducer.customPicklistOptions);
  const bulkEditTasks = useSelector((state) => state.taskViewPageReducer.bulkEditTasks);
  const selectedTasks = _.get(bulkEditTasks, 'items');
  const [isLoading, setisLoading] = React.useState([]);
  const taskTypeCheck = (selectedTasksList) => {
    const taskListIds = [];
    selectedTasksList.forEach((taskObj) => {
      taskListIds.push(taskObj.taskTypeId);
    });

    return { similarTaskType: _.uniq(taskListIds).length === 1, taskListIds };
  };

  const isLoadingFromRedux = useSelector((state) => state.taskViewPageReducer.bulkEditTasks.isLoading);

  const initialValues = useSelector((state) => state.manageTaskFormReducer.formValues);
  const task = useSelector((state) => state.manageTaskFormReducer.task);

  const selectedTasksNumber = () => {
    const numberArray = [];
    selectedTasks.forEach((tasksObj) => {
      numberArray.push(_.get(tasksObj, 'taskNumber', ''));
    });
    return numberArray.join(',');
  };
  React.useEffect(() => {
    setisLoading((prevState) => !prevState);
  }, [isLoadingFromRedux]);

  const onCancel = () => {
    history.goBack();
  };

  React.useEffect(() => {
    async function callApi() {
      try {
        setisLoading(true);
        if (!_.isEmpty(selectedTasks)) {
          const { similarTaskType, taskListIds } = taskTypeCheck(selectedTasks);
          await dispatch(taskActions.loadBulkEdittaskForm(selectedTasks, similarTaskType, taskListIds));
          setisLoading(false);
        } else {
          history.push('/taskViewPage');
        }
      } catch (e) {
        setisLoading(false);
        console.error(e);
      } finally {
        setisLoading(false);
      }
    }
    callApi();
    return () => {
      // dispatch(taskActions.resetTaskFormComponent());
      dispatch(closeView(CONTAINERS.TASK_VIEW));
    };
  }, []);
  const sortFunctionForAttributesInSchema = (attributeObj1, attributeObj2) => {
    const seq1 = !_.isNil(attributeObj1.sequence) ? attributeObj1.sequence : 1000;
    const seq2 = !_.isNil(attributeObj2.sequence) ? attributeObj2.sequence : 1000;
    const seqDiff = seq1 - seq2;
    if (seqDiff === 0) {
      return (attributeObj1.displayName || attributeObj1.name).localeCompare(
        attributeObj2.displayName || attributeObj2.name
      );
    }
    return seq1 - seq2;
  };

  function mapSchemaToSystemAndCustom(schema) {
    const customSchema = [];
    const systemSchema = [];
    const scheduleSchema = [];
    const auditSchema = [];
    const notificationSchema = [];
    const partsSchema = [];
    const globalSchema = [];
    const approvalSchema = [];
    const watchergroupSchema = [];
    let attachmentSchema;
    for (const [attributeName, attributeObj] of Object.entries(schema)) {
      if (typeof attributeObj !== 'object') continue;
      const newAttributeObj = _.clone(attributeObj);
      newAttributeObj.attributeName = attributeName;
      if (
        attributeName.startsWith('s_') &&
        attributeName !== 's_name' &&
        attributeName !== 's_timespent' &&
        attributeName !== 's_desc' &&
        attributeName !== 's_estimatedtime'
      ) {
        systemSchema.push(newAttributeObj);
      }
      if (attributeName.startsWith('c_')) {
        customSchema.push(newAttributeObj);
      }
      if (attributeName.startsWith('g_')) {
        globalSchema.push(newAttributeObj);
      }
      if (attributeName.startsWith('schedule_')) {
        scheduleSchema.push(newAttributeObj);
      }
      if (attributeName.startsWith('audit_')) {
        auditSchema.push(newAttributeObj);
      }
      if (attributeName.startsWith('notification_')) {
        notificationSchema.push(newAttributeObj);
      }
      if (attributeName.startsWith('parts_')) {
        partsSchema.push(newAttributeObj);
      }
      if (attributeName.startsWith('watcher_')) {
        watchergroupSchema.push(newAttributeObj);
      }
      if (attributeName.startsWith('approval_')) {
        approvalSchema.push(newAttributeObj);
      }
      if (attributeName === ATTACHMENT_SCHEMA) {
        attachmentSchema = newAttributeObj;
      }
    }
    systemSchema.sort(sortFunctionForAttributesInSchema);
    customSchema.sort(sortFunctionForAttributesInSchema);
    scheduleSchema.sort(sortFunctionForAttributesInSchema);
    auditSchema.sort(sortFunctionForAttributesInSchema);
    approvalSchema.sort(sortFunctionForAttributesInSchema);
    globalSchema.sort(sortFunctionForAttributesInSchema);
    return {
      customSchema,
      systemSchema,
      scheduleSchema,
      auditSchema,
      notificationSchema,
      partsSchema,
      globalSchema,
      approvalSchema,
      attachmentSchema,
      watchergroupSchema,
    };
  }

  const schema = useSelector((state) => state.manageTaskFormReducer.schema);

  const {
    systemSchema,
    customSchema,
    scheduleSchema,
    notificationSchema,
    globalSchema,
    watchergroupSchema,
    attachmentSchema,
  } = mapSchemaToSystemAndCustom(schema);

  const onScoreOrIncrementChange = () => {
    console.log('🚀 ~ file: BulkEditTaskForm.jsx ~ line 241 ~ onScoreOrIncrementChange ~ onScoreOrIncrementChange');
  };

  const handleClickAssignee = (assigneeId) => {
    dispatch(
      resetView(CONTAINERS.TASK_VIEW, {
        component: UserCard,
        props: {
          assigneeId,
        },
      })
    );
  };

  const onAssigneeChange = async ({ value, formik }) => {
    if (!_.size(value)) {
      return;
    }
    formik.setFieldValue('s_assigneeid', value, false);
  };
  const assigneeOptions = useSelector((state) => state.manageTaskFormReducer.assigneeOptions);
  const taskTypeOptions = useSelector((state) => state.manageTaskFormReducer[PICKLIST_OPTIONS.TASK_TYPE]);
  let props = {};

  const loggedInUser = useSelector((state) => state.appReducer.loggedInUser);

  props = {
    onValueChange: {
      onScoreOrIncrementChange,
      viewAssigneeDetals: handleClickAssignee,
      onAssigneeChange,
    },
    loggedInUser,
    taskTypeOptions,
    assigneeOptions,
    eventSourceOptions,
    priorityOptions,
    statusOptions,
    selectedTasks,
    customPicklistOptions,
  };

  const cleanObj = (obj) => {
    for (const key in obj) {
      if (
        obj[key] === null ||
        obj[key] === undefined ||
        obj[key] === [] ||
        obj[key] === {} ||
        obj[key] === '' ||
        (_.isArray(obj[key]) && _.isEmpty(obj[key]))
      ) {
        delete obj[key];
      } else if (_.isObject(obj[key])) {
        for (const keyValue in obj[key]) {
          if (obj[key][keyValue] === null || obj[key][keyValue] === undefined || obj[key][keyValue] === []) {
            delete obj[key][keyValue];
          } else if (
            _.isObject(obj[key][keyValue]) &&
            _.isArray(Object.keys(obj[key][keyValue])) &&
            Object.keys(obj[key][keyValue]).length > 0
          ) {
            // eslint-disable-next-line no-unused-vars
            for (const [tempKey, tempvalue] of Object.entries(obj[key][keyValue])) {
              if (_.isEmpty(tempvalue)) {
                delete obj[key][keyValue][tempKey];
              }
            }
          }
        }
      } else if (key === 'assigneeIds') {
        delete obj[key];
      }
    }

    return obj;
  };
  const tempClean = (obj) => {
    const tempObj = _.cloneDeep(obj);

    const temp = cleanObj(tempObj);

    for (const key in temp) {
      if (
        temp[key] === null ||
        temp[key] === undefined ||
        temp[key] === [] ||
        temp[key] === {} ||
        (_.isArray(temp[key]) && _.isEmpty(temp[key]))
      ) {
        delete temp[key];
      }
    }
    return temp;
  };

  const cleanMargeTemp = (cleanTask, tasks) => {
    const tasksCopy = _.cloneDeep(tasks);
    const tempTask = [];
    for (const taskObj of tasksCopy) {
      const globalAttribute = _.get(taskObj, 'globalAttributes', {});
      const tempbulkEditglobalAttribute = _.get(cleanTask, 'globalAttributes', {});
      const bulkEditglobalAttribute = tempbulkEditglobalAttribute;
      const data = parseJSONStringToObject(_.get(taskObj, 'data', '{}'));
      const tempData = parseJSONStringToObject(_.get(cleanTask, 'data', '{}'));
      taskObj.data = _.merge(data, tempData);
      const prevStatus = taskObj.status;
      const currStatus = cleanTask.status;
      if (currStatus !== prevStatus && currStatus === STATUS_LIST.RESOLVED.key) {
        taskObj.data.s_resolved_device = RESOLVED_VIA.ADMIN;
        taskObj.resolvedOn = new Date().toISOString();
        taskObj.resolvedBy = loggedInUser.userName;
      }
      let tempglobalAttribute = {};
      tempglobalAttribute = _.merge(globalAttribute, bulkEditglobalAttribute);

      taskObj.globalAttributes = tempglobalAttribute;
      for (const [formKey, formValue] of Object.entries(cleanTask)) {
        // to ignore already mapped values
        // do not add assigneeIds if bulk Accept is true
        if (formKey !== 'assigneeIds' && formKey !== 'globalAttributes' && formKey !== 'data') {
          taskObj[formKey] = formValue;
        }
      }
      tempTask.push(taskObj);
    }

    return tasksCopy;
  };

  const assigneeMapper = () => {
    const items = _.get(assigneeOptions, 'items', []);
    const assigneeListItem = _.cloneDeep(items);
    const returnList = [];
    if (assigneeListItem) {
      assigneeListItem.forEach((e) => {
        const obj = _.get(e, 'originalobject', {});
        returnList.push(obj);
      });
    }
    return returnList;
  };

  const bulkAcceptTaskComments = async (formik, acceptBulkAccept, clonedSelectedTasks) => {
    dispatch(bulkEditPageLoading());
    if (clonedSelectedTasks && acceptBulkAccept) {
      dispatch(taskActions.bulkAcceptTaskAction(clonedSelectedTasks));

      // const { assigneeId } = selectedTasks[0].assigneeIds[0];
      formik.setFieldValue('s_status', STATUS_LIST.OPEN.key, false);
      // not required
      // onAssigneeChange({ name: 's_assigneeid', value: [assigneeId], formik });
      // for (const taskObj of selectedTasks) {
      //   const reqTaskClone = _.cloneDeep(taskObj);
      //   const { assigneeIds } = reqTaskClone;
      //   // assuming the length of the assigneeList is one and the assignee is same of the all the selectedTasks
      //   const reqAssignee = assigneeIds[0];
      //   // const reqAssignee = assigneeIds.find((assignee) => assignee.assigneeId === assigneeId);
      //   reqAssignee.isAccepted = true;
      //   reqAssignee.acceptedOn = new Date().toISOString();
      //   reqTaskClone.assigneeIds = [reqAssignee];
      //   reqTaskClone.status = 'open';

      //   returnTasksList.push(reqTaskClone);

      //   // addComments({ dispatch, reqAssignee, loggedInUser, taskObj, selectedField });
      //   // toastr.success('Task Accepted Sucessfully');
      //   // setbulkAcceptTaskStatevalue(true);
      // }

      dispatch(stopBulkEditPageLoading());
      return clonedSelectedTasks;
    }
    dispatch(stopBulkEditPageLoading());

    // toastr.error('No task found');
    // setbulkAcceptTaskStatevalue(false);
    return clonedSelectedTasks;
  };

  const validateForm = (formValues) => {
    const errorObject = Object.entries(schema).reduce((errors, [attributeName, attributeObject]) => {
      if (
        attributeObject.isMandatory ||
        (attributeObject.requiredOnResolve && formValues.s_status === STATUS_LIST.RESOLVED.key)
      ) {
        const validationObj = validateMandatoryAttribute(attributeObject, formValues[attributeName]);
        if (!validationObj.validation) {
          errors[attributeName] = validationObj.message;
          return errors;
        }
      }

      if (attributeObject.validations && typeof attributeObject.validations === 'function') {
        const validation = attributeObject.validations({ formValues });
        if (!validation.isValid) errors[attributeName] = validation.error;
      } else if (attributeObject.validations && attributeObject.validations.length > 0) {
        for (const validation of attributeObject.validations) {
          if (!validation.validateFunc({ formValues, selectedTasks })) {
            errors[attributeName] = validation.message;
            break;
          }
        }
      }
      return errors;
    }, {});
    return errorObject;
  };

  const { acceptBulkAccept } = useSelector((state) => state.manageTaskFormReducer);
  const selectedField = useSelector((state) => state.appReducer.selectedField);

  const validateOverallTaskForm = async (formik) => {
    const validationResponse = await formik.validateForm();

    return _.isEmpty(validationResponse);
  };

  const onCreateButtonClicked = async (values, formik) => {
    const isTaskFormValid = await validateOverallTaskForm(formik);
    if (isTaskFormValid) {
      const { userName } = loggedInUser;
      const clonedSelectedTasks = _.cloneDeep(selectedTasks);
      changeRecurringRule(values, clonedSelectedTasks);

      // if bulkaccept flag is true

      const acceptedSelectedTasks = await bulkAcceptTaskComments(formik, acceptBulkAccept, clonedSelectedTasks);

      // converting formvalues to recongnizable object
      const updatedTasks = mapFormValuesToEntity(_.omit(values, ['schedule_recurring']), schema, {
        customPicklistOptions,
        taskTypeOptions,
        clonedSelectedTasks,
      });
      const cleanTask = tempClean(updatedTasks);
      // merging selectedTasks with formValues
      const cleanMergedTasks = cleanMargeTemp(cleanTask, acceptedSelectedTasks, acceptBulkAccept);
      const assigneeList = assigneeMapper();

      const updatedTasksWithAssignee = mergeAttributesForBulkEditTasks(
        cleanMergedTasks,
        values,
        assigneeList,
        userName,
        acceptBulkAccept,
        acceptedSelectedTasks
      );

      const tasksEditMode = 'PUBLISHED';
      try {
        const promise = [];
        promise.push(dispatch(editBulkTasks(updatedTasksWithAssignee, userName, tasksEditMode)));
        // comment and notification changes
        if (acceptBulkAccept) {
          for (const taskObj of updatedTasksWithAssignee) {
            const assigneeId = _.get(taskObj, 'assigneeIds');
            const assigneeOptionsArray = _.get(assigneeOptions, 'items', []);
            let reqAssignee = {};
            if (taskObj?.taskType?.needEquipment) {
              const { equipmentId } = getOperatorIdAndEquipmentId(_.get(taskObj, 'assigneeIds') || []);
              reqAssignee = assigneeOptionsArray.filter((item) => item.key === equipmentId);
            } else {
              reqAssignee = assigneeOptionsArray.filter((item) => item.key === assigneeId[0].assigneeId);
            }

            promise.push(addComments({ dispatch, reqAssignee, loggedInUser, taskObj, selectedField }));
          }
        }

        await Promise.allSettled(promise);
        handleClearSelectedTasks();
        // await dispatch(editBulkTasks(updatedTasksWithAssignee, userName, tasksEditMode));
        history.goBack();
      } catch (e) {
        // toastr.error('Task Update failed');
        console.log('🚀 ~ file: BulkEditTaskForm.jsx ~ line 292 ~ onCreateButtonClicked ~ e', e);
      }
    }
  };

  async function createOrUpdateTask(createOrUpdateFunc, formik) {
    try {
      const res = await createOrUpdateFunc(formik.values, formik);
      if (res) {
        history.goBack();
      }
    } catch (error) {
      console.error(error);
    }
  }

  const notificationWatchers = useSelector((state) => state.manageTaskFormReducer.notificationWatchers);
  const watchergroups = useSelector((state) => state?.watcherGroupReducer?.watchergroups);
  return (
    <>
      {isLoading && <Joyn2Loader />}
      <Container fluid id="task-form" className="container-above-task-view-grid">
        <FormHeader title="Bulk Edit" onCancel={cancelTask} />
        <Grid style={{ height: 'calc(100% - 48px' }} padded>
          <Grid.Row style={{ height: '100%' }}>
            <Grid.Column
              style={{ height: '100%' }}
              //  width={originalTask.id ? 11 : 16}
              width={16}
            >
              <Formik
                enableReinitialize
                initialValues={initialValues}
                validate={validateForm}
                validateOnBlur={false}
                validateOnChange={false}
              >
                {(formik) => {
                  return (
                    <form
                      style={{
                        height: '100%',

                        paddingLeft: '14px',
                        paddingRight: '14px',
                      }}
                      className="ui form"
                    >
                      <Segment style={{ paddingBottom: '36px' }} className="selected-tasks">
                        <Grid>
                          <Grid.Row style={{ marginLeft: '5px' }}>
                            <Grid.Column width={16}>
                              <Grid style={{ marginTop: '0px', marginBottom: '0px' }}>
                                <Grid.Row>
                                  <div>Selected Tasks</div>
                                  <div style={{ padding: '0px 10px' }}>{selectedTasksNumber()}</div>
                                </Grid.Row>
                              </Grid>
                            </Grid.Column>
                          </Grid.Row>
                        </Grid>
                      </Segment>
                      <Segment style={{ paddingBottom: '36px' }}>
                        <Grid>
                          <Grid.Row>
                            {systemSchema.map((attributeObj) => (
                              <TaskFormField
                                attributeObj={attributeObj}
                                key={attributeObj.attributeName}
                                formik={formik}
                                task={task}
                                {...props}
                              />
                            ))}
                          </Grid.Row>
                        </Grid>
                      </Segment>
                      <Segment style={{ border: '1px solid #e5e5e5', marginTop: '10px' }}>
                        <Grid>
                          <Grid.Row className="form-group-header">Scheduling Details</Grid.Row>

                          <Grid.Row style={{ marginLeft: '5px' }}>
                            <Grid.Column width={16}>
                              <Grid style={{ marginTop: '0px', marginBottom: '0px' }}>
                                <Grid.Row>
                                  {scheduleSchema
                                    .filter(
                                      (attributeObj) =>
                                        !isFormAttributeHiddenOrInvalid(attributeObj, {
                                          formValues: formik.values,
                                          task,
                                          selectedTasks,
                                        })
                                    )
                                    .map((attributeObj) => {
                                      return (
                                        <TaskFormField
                                          attributeObj={attributeObj}
                                          key={attributeObj.attributeName}
                                          formik={formik}
                                          task={task}
                                          {...props}
                                        />
                                      );
                                    })}
                                </Grid.Row>
                              </Grid>
                            </Grid.Column>
                          </Grid.Row>
                        </Grid>
                      </Segment>
                      {globalSchema.length > 0 && (
                        <Segment style={{ border: '1px solid #e5e5e5', marginTop: '10px' }}>
                          <Grid>
                            <Grid.Row className="form-group-header">Global Task Attributes</Grid.Row>
                            <Grid.Row style={{ marginLeft: '5px' }}>
                              <Grid.Column width={16}>
                                <Grid style={{ marginTop: '0px', marginBottom: '0px' }}>
                                  <Grid.Row>
                                    {globalSchema.map((attributeObj) => {
                                      return (
                                        <TaskFormField
                                          key={attributeObj.attributeName}
                                          attributeObj={attributeObj}
                                          formik={formik}
                                          task={task}
                                          {...props}
                                        />
                                      );
                                    })}
                                  </Grid.Row>
                                </Grid>
                              </Grid.Column>
                            </Grid.Row>
                          </Grid>
                        </Segment>
                      )}
                      {customSchema.some((attributeObj) => {
                        return !isFormAttributeHiddenOrInvalid(attributeObj, { formValues: formik.values, task });
                      }) && (
                        <Segment>
                          <Grid>
                            <Grid.Row className="form-group-header">Task Type Attributes</Grid.Row>
                            <Grid.Row style={{ marginLeft: '5px' }}>
                              <Grid.Column width={16}>
                                <Grid style={{ marginTop: '0px', marginBottom: '0px' }}>
                                  <Grid.Row>
                                    {customSchema.map((attributeObj) => {
                                      return (
                                        <TaskFormField
                                          key={attributeObj.attributeName}
                                          attributeObj={attributeObj}
                                          formik={formik}
                                          task={task}
                                          {...props}
                                        />
                                      );
                                    })}
                                  </Grid.Row>
                                </Grid>
                              </Grid.Column>
                            </Grid.Row>
                          </Grid>
                        </Segment>
                      )}
                      <Segment style={{ border: '1px solid #e5e5e5', marginTop: '50px' }}>
                        {attachmentSchema && (
                          <TaskFormField formik={formik} attributeObj={attachmentSchema} task={task} />
                        )}
                      </Segment>
                      <Segment style={{ border: '1px solid #e5e5e5', marginTop: '10px' }}>
                        <Grid>
                          <Grid.Row className="form-group-header">Watchers</Grid.Row>

                          <Grid.Row style={{ marginLeft: '5px' }}>
                            <Grid.Column width={16}>
                              <Grid style={{ marginTop: '0px', marginBottom: '0px' }}>
                                <Grid.Row>
                                  {notificationSchema.map((attributeObj) => {
                                    return (
                                      <TaskFormField
                                        attributeObj={attributeObj}
                                        key={attributeObj.attributeName}
                                        formik={formik}
                                        task={task}
                                        notificationWatchers={notificationWatchers}
                                        {...props}
                                      />
                                    );
                                  })}
                                </Grid.Row>
                              </Grid>
                            </Grid.Column>
                          </Grid.Row>
                        </Grid>
                      </Segment>
                      <Segment style={{ border: '1px solid #e5e5e5', marginTop: '10px' }} id="watchergroupSegment">
                        <Grid>
                          <Grid.Row className="form-group-header">Watchergroups</Grid.Row>

                          <Grid.Row style={{ marginLeft: '5px' }}>
                            <Grid.Column width={16}>
                              <Grid style={{ marginTop: '0px', marginBottom: '0px' }}>
                                <Grid.Row>
                                  {watchergroupSchema.map((attributeObj) => {
                                    return (
                                      <TaskFormField
                                        attributeObj={attributeObj}
                                        key={attributeObj.attributeName}
                                        formik={formik}
                                        task={task}
                                        watcherGroups={watchergroups.map((val) => {
                                          return {
                                            key: val.id,
                                            value: val.id,
                                            text: val.name,
                                          };
                                        })}
                                        {...props}
                                      />
                                    );
                                  })}
                                </Grid.Row>
                              </Grid>
                            </Grid.Column>
                          </Grid.Row>
                        </Grid>
                      </Segment>
                      <Grid>
                        <Grid.Row className="form-button-row">
                          <Grid.Column width={16}>
                            <ShouldComponentRender
                              resource={RESOURCES.ENTITY.TASK}
                              resourceType={RESOURCE_TYPE.ENTITY}
                              entityAccessType={ENTITY_ACCESS_TYPE.UPDATE}
                              entity={task}
                            >
                              <Button
                                primary
                                type="button"
                                onClick={() => {
                                  createOrUpdateTask(onCreateButtonClicked, formik);
                                }}
                              >
                                Update
                              </Button>
                            </ShouldComponentRender>
                            <Button basic type="button" onClick={onCancel}>
                              Cancel
                            </Button>
                          </Grid.Column>
                        </Grid.Row>
                      </Grid>
                    </form>
                  );
                }}
              </Formik>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        {/* <Modal
          ref={confirmDeleteModal}
          render={(props) => (
            <Confirm
              size="tiny"
              header="Warning"
              content="Deleting linked task cannot be undone. Are you sure you would like to continue?"
              onCancel={closeConfirmDeleteModal()}
              open
              {...props}
            />
          )}
        /> */}
        <CardNavigationComponent container={CONTAINERS.TASK_VIEW} />
      </Container>
    </>
  );
};
export default BulkEditTaskForm;
